'use client'

import React, { useEffect, useRef } from "react"
import "./SkipToContent.css"

const SkipToContent = () => {
      const linkRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Tab") {
        // If focus is on body or nothing is focused, move focus to the 'Skip to content' link (mimic behavior in Gatsby)
        const active = document.activeElement
        if (active === document.body || active === null) {
          linkRef.current?.focus()
          e.preventDefault()
        }
      }
    }

    document.addEventListener("keydown", handleKeyDown)
    return () => document.removeEventListener("keydown", handleKeyDown)
  }, [])
  return (
    //TODO: Render 'Skip to content' label from Contenful label ...
    //...list instead of hard coding it for translation purposes.
    <a ref={linkRef} className="skip-to-content" href="#page-content">
      Skip to content
    </a>
  )
}

export default SkipToContent
